var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.htmlTag,{tag:"component",style:(_vm.style)},[_vm._t("default"),_c('grid-viewport-listener',{model:{value:(_vm.size),callback:function ($$v) {_vm.size=$$v},expression:"size"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }